import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSharedExperiencesApi } from './useSharedExperiencesApi';
import { AuthContext } from '../../auth/lib/authContext';
const SharedExperiencesContext = createContext();
export const useSharedExperiencesContext = () => {
  const context = useContext(SharedExperiencesContext);
  if (!context) {
    throw new Error('useSharedExperiencesContext must be used within a SharedExperiencesProvider');
  }
  return context;
};
export const SharedExperiencesProvider = ({ children, sharedExperienceId, onInit }) => {
  const { profile } = useContext(AuthContext);
  const [sharedExperience, setSharedExperience] = useState(null);
  const [rights, setRights] = useState({ can_update: false, can_delete: false, can_select: false });
  const [role, setRole] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const sharedExperiencesApi = useSharedExperiencesApi();
  useEffect(() => {
    if (sharedExperienceId && profile) {
      loadSharedExperienceData();
    }
  }, [sharedExperienceId, profile]);
  const loadSharedExperienceData = async () => {
    try {
      setLoading(true);
      const [seData, rightsData, roleData, statusData] = await Promise.all([
        sharedExperiencesApi.fetchSharedExperienceById(sharedExperienceId),
        sharedExperiencesApi.fetchUserRights(sharedExperienceId, profile.id),
        sharedExperiencesApi.fetchMemberRole(sharedExperienceId, profile.id),
        sharedExperiencesApi.fetchMemberStatus(sharedExperienceId, profile.id)
      ]);
      setSharedExperience(seData);
      setRights(rightsData || { can_update: false, can_delete: false, can_select: false });
      setRole(roleData);
      setStatus(statusData);
      if (onInit) {
        onInit();
      }
    } catch (error) {
      console.error('❌ Error in loadSharedExperienceData:', error);
      setRights({ can_update: false, can_delete: false, can_select: false });
      setRole(null);
      setStatus(null);
    } finally {
      setLoading(false);
    }
  };
  const value = {
    sharedExperienceId,
    sharedExperience,
    rights,
    role,
    status,
    loading,
    refreshRights: loadSharedExperienceData,
    refreshSharedExperience: loadSharedExperienceData
  };
  return (
    <SharedExperiencesContext.Provider value={value}>
      {children}
    </SharedExperiencesContext.Provider>
  );
};
export { SharedExperiencesContext }; 